import React, { useState, useEffect } from 'react';
import './sidebar.css';

const Sidebar = () => {
  const [toggle, showMenu] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  const handleMenuToggle = () => {
    showMenu(!toggle);
  };

  const handleNavLinkClick = (section) => {
    setActiveSection(section);
    showMenu(false);
  };

  // Handle scroll to highlight active section
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'services', 'resume', 'work', 'review', 'blog', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;
          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { icon: '🏠', label: 'Home', href: '#home', id: 'home' },
    { icon: '👤', label: 'About', href: '#about', id: 'about' },
    { icon: '⚡', label: 'Services', href: '#services', id: 'services' },
    { icon: '📜', label: 'Resume', href: '#resume', id: 'resume' },
    { icon: '🎯', label: 'Portfolio', href: '#work', id: 'work' },
    { icon: '💰', label: 'Pricing', href: '#pricing', id: 'pricing' },
    { icon: '⭐', label: 'Reviews', href: '#review', id: 'review' },
    { icon: '📝', label: 'Blog', href: '#blog', id: 'blog' },
    { icon: '✉️', label: 'Contact', href: '#contact', id: 'contact' },
  ];

  return (
    <>
      <aside className={`sidebar ${toggle ? 'sidebar-open' : ''}`}>
        {/* Logo */}
        <a href="#home" className="sidebar__logo" onClick={() => handleNavLinkClick('home')}>
          <div className="logo-wrapper">
            <div className="logo-icon">⚡</div>
            <div className="logo-text">
              <span className="logo-char">I</span>
              <span className="logo-char">P</span>
              <span className="logo-char">M</span>
            </div>
          </div>
        </a>

        {/* Navigation */}
        <nav className="sidebar__nav">
          <ul className="sidebar__nav-list">
            {navItems.map((item) => (
              <li key={item.id} className="sidebar__nav-item">
                <a
                  href={item.href}
                  className={`sidebar__nav-link ${activeSection === item.id ? 'active' : ''}`}
                  onClick={() => handleNavLinkClick(item.id)}
                  aria-label={item.label}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                  <span className="nav-indicator"></span>
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Footer */}
        <div className="sidebar__footer">
          <div className="footer-divider"></div>
          <span className="footer-copyright">© 2026</span>
          <div className="footer-status">
            <span className="status-dot"></span>
            <span className="status-text">Online</span>
          </div>
        </div>
      </aside>

      {/* Mobile Toggle */}
      <button
        className={`sidebar__toggle ${toggle ? 'open' : ''}`}
        onClick={handleMenuToggle}
        aria-label="Toggle navigation"
      >
        <span className="toggle-line"></span>
        <span className="toggle-line"></span>
        <span className="toggle-line"></span>
      </button>
    </>
  );
};

export default Sidebar;